import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentResult({ kind }) {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [payment, setPayment] = useState(null);
  const [checking, setChecking] = useState(kind === "success");

  useEffect(() => {
    if (kind !== "success" || !sessionId) return;
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setPayment(data);
          setChecking(false);
          return;
        }
      } catch (e) {
        // keep polling briefly
      }
      attempts += 1;
      if (attempts < 8) setTimeout(poll, 2000);
      else setChecking(false);
    };
    poll();
  }, [kind, sessionId]);

  return (
    <main className="min-h-screen bg-cream flex items-center justify-center px-6" data-testid="payment-result-page">
      <div className="bg-white rounded-2xl border border-linen p-10 sm:p-14 max-w-lg w-full text-left">
        {kind === "success" ? (
          <>
            {checking ? (
              <Loader2 className="w-10 h-10 text-clay animate-spin" data-testid="payment-checking" />
            ) : (
              <CheckCircle2 className="w-12 h-12 text-clay" strokeWidth={1.5} data-testid="payment-success-icon" />
            )}
            <h1 className="font-display text-3xl sm:text-4xl tracking-tight font-medium mt-6" data-testid="payment-success-heading">
              {checking ? "Confirming your deposit…" : "Deposit received."}
            </h1>
            <p className="text-moss text-base leading-relaxed mt-4">
              {checking
                ? "We're confirming your payment with Stripe — this takes a few seconds."
                : "Your beef share is officially reserved. We'll email you within 48 hours with your harvest window and butcher cut sheet. Welcome to the ranch."}
            </p>
            {payment && (
              <p className="text-xs text-moss mt-4" data-testid="payment-session-id">Confirmation: {payment.session_id}</p>
            )}
          </>
        ) : (
          <>
            <XCircle className="w-12 h-12 text-clay" strokeWidth={1.5} data-testid="payment-cancel-icon" />
            <h1 className="font-display text-3xl sm:text-4xl tracking-tight font-medium mt-6" data-testid="payment-cancel-heading">
              Checkout cancelled.
            </h1>
            <p className="text-moss text-base leading-relaxed mt-4">
              No charge was made. Your reservation details are safe — you can pick up right where you left off.
            </p>
          </>
        )}
        <Link
          to="/"
          data-testid="payment-back-home-btn"
          className="inline-block mt-10 rounded-full bg-forest text-cream font-semibold px-8 py-3.5 text-sm hover:bg-forest/90 hover:-translate-y-0.5 hover:shadow-md transition-[background-color,transform,box-shadow] duration-200"
        >
          Back to the ranch
        </Link>
      </div>
    </main>
  );
}
